const addFolderKey = (name: string) => {
  return `folder_name_${name}_folder_name`
}

export default addFolderKey